import { ohneAudioMarke } from "../../shared/audio-marke.js";

/**
 * Der Abgleichs-Schlüssel einer Nachricht: die ersten 80 Zeichen des Gesagten.
 *
 * Der Servertext einer Sprachnachricht trägt am Ende die Audio-Marke, die
 * Blase und der lokale Verlauf nicht. Ohne Abschneiden der Marke passen beide
 * Seiten nie zusammen und das Nachladen zeichnet die Nachricht ein zweites Mal.
 */
export function verlaufSchluessel(text: string | null | undefined): string {
  return ohneAudioMarke(text ?? "").slice(0, 80).trim();
}

/**
 * Der Abgleichs-Schlüssel einer Verlaufszeile mit Rolle. Martins Tipp auf eine Karte trägt zusätzlich die Kartenkennung:
 * ohne sie hielte der Abgleich jedes „Ja“ für das Doppel eines früheren „Ja“ — die Zeile mit dem Kartenbezug (die die Karte
 * nach dem Neuladen sperrt und die Wahl zeigen lässt) würde verworfen (21.10.2026, Karte k-ccdc5c).
 */
export function zeilenSchluessel(rolle: string, text: string | null | undefined, karteKennung?: string | null): string {
  const basis = `${rolle}|${verlaufSchluessel(text)}`;
  return karteKennung && /^[0-9a-f]{6}$/.test(karteKennung) ? `${basis}|karte:${karteKennung}` : basis;
}
